
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/d/[link]/[slug]",
      function () {
        return require("private-next-pages/d/[link]/[slug].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/d/[link]/[slug]"])
      });
    }
  